/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { chatShow } from '../../axios/chatShow'
import type { ChatShowError, ChatShowPathParams, ChatShowQueryParams, ChatShowResponse } from '../../types/ChatShow'

export const chatShowQueryKey = (chat: ChatShowPathParams['chat'], params?: ChatShowQueryParams) =>
	[{ url: '/chat/:chat', params: { chat } }, ...(params ? [params] : [])] as const

export type ChatShowQueryKey = ReturnType<typeof chatShowQueryKey>

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::show */
export function chatShowQueryOptions(
	chat: ChatShowPathParams['chat'],
	params?: ChatShowQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<ChatShowResponse, AxiosError<ChatShowError>, ChatShowResponse, ChatShowQueryKey>({
		queryKey: chatShowQueryKey(chat, params),
		queryFn: ({ signal }) => chatShow(chat, params, { signal, ...config }).then(res => res.data),
		enabled: !!chat,
	})
}

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::show */
export function useChatShow<TSelectData = ChatShowResponse>(
	chat: ChatShowPathParams['chat'],
	params?: ChatShowQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<ChatShowResponse, AxiosError<ChatShowError>, TSelectData, ChatShowQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<ChatShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...chatShowQueryOptions(chat, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::show */
export function useChatShowSuspense<TSelectData = ChatShowResponse>(
	chat: ChatShowPathParams['chat'],
	params?: ChatShowQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<ChatShowResponse, AxiosError<ChatShowError>, TSelectData, ChatShowQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<ChatShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...chatShowQueryOptions(chat, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
